export default function getThisYear(){
    const fecha = new Date();
    return fecha.getFullYear();
}

